import React from "react";
// import RadioButton from "./RadioButton";
import Checkbox from "./Checkbox";

const CheckboxSelection = ({
  label,
  divClassName,
  internalDivClass,
  secondRadioClass,
  textClass,
  checkClass,
  name,
  value,
  error,
  touched,
  setFieldValue,
  options,
  onChecked,
  postIcon,
  twoColumns = true,
}) => {
  
  const handleChecked = (op) => {
    const isSelected = value.find((v) => v === op);
    if (isSelected) {
      const updatedValues = value?.filter((rule) => rule !== op);
      setFieldValue(name, updatedValues);
    } else {
      setFieldValue(name, [...value, op]);
    }
  };

  return (
    <div className={divClassName}>
      <p className="lg:text-[16px] sm:text-[14px] font-[400] text-[#303030] mb-3 font-poppins">
        {label}
      </p>
      {twoColumns ? (
        (() => {
          const mid = Math.ceil((options?.length || 0) / 2);
          const leftOptions = options?.slice(0, mid) || [];
          const rightOptions = options?.slice(mid) || [];
          return (
            <div className="flex flex-col md:flex-row md:justify-between md:gap-x-28 lg:gap-x-36">
              <div className="w-full md:w-[48%] space-y-1.5 max-w-[560px]">
                {leftOptions.map((op, index) => (
                  <div className={internalDivClass} key={`left-${op}-${index}`}>
                    <div className={`flex items-center justify-between ${index > 0 ? secondRadioClass : ""}`}>
                      <Checkbox
                        divClassName={checkClass}
                        text={op}
                        checked={value?.includes(op)}
                        onChecked={onChecked ? () => onChecked(op) : () => handleChecked(op)}
                        textClass={textClass}
                      />
                      {postIcon ? <img src={postIcon} className="ml-8 w-[80px]" alt="" /> : null}
                    </div>
                  </div>
                ))}
              </div>
              <div className="w-full md:w-[48%] space-y-1.5 max-w-[560px]">
                {rightOptions.map((op, index) => (
                  <div className={internalDivClass} key={`right-${op}-${index}`}>
                    <div className={`flex items-center justify-between ${index > 0 ? secondRadioClass : ""}`}>
                      <Checkbox
                        divClassName={checkClass}
                        text={op}
                        checked={value?.includes(op)}
                        onChecked={onChecked ? () => onChecked(op) : () => handleChecked(op)}
                        textClass={textClass}
                      />
                      {postIcon ? <img src={postIcon} className="ml-8 w-[80px]" alt="" /> : null}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })()
      ) : (
        <div className={`grid grid-cols-1 gap-y-6`}>
          {options?.map((op, index) => (
            <div className={internalDivClass} key={`${op}-${index}`}>
              <div className={`flex items-center justify-between ${index > 0 ? secondRadioClass : ""}`}>
                <Checkbox
                  divClassName={checkClass}
                  text={op}
                  checked={value?.includes(op)}
                  onChecked={onChecked ? () => onChecked(op) : () => handleChecked(op)}
                  textClass={textClass}
                />
                {postIcon ? <img src={postIcon} className="ml-8 w-[80px]" alt="" /> : null}
              </div>
            </div>
          ))}
        </div>
      )}
      {error && touched ? (
        <span className="text-red-600 sm:text-[10px] md:text-[12px] font-[600] ms-1">
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default CheckboxSelection;
